var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('van-search',{attrs:{"placeholder":"请输入搜索关键词","shape":"round","background":_vm.back_color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }